import Vue from "vue"
import numeral from 'numeral'

Vue.filter("format", (value, format) => {
	return numeral(value).format(format)
})

Vue.filter("flatten", data => {
	let result = {};

	function recurse(cur, prop) {
		if (Object(cur) !== cur) {
			result[prop] = cur;
		} else if (Array.isArray(cur)) {
			for (let i = 0; i < l; i++)
				recurse(cur[i], prop + "[" + i + "]");
			if (cur.length === 0)
				result[prop] = [];
		} else {
			let isEmpty;
			for (let p in cur) {
				isEmpty = false;
				recurse(cur[p], prop ? prop + "." + p : p);
			}
			if (isEmpty && prop)
				result[prop] = {};
		}
	}

	recurse(data, "");
	return result;
})